import endOfToday from 'date-fns/endOfToday'
import isAfter from 'date-fns/isAfter'
import isValid from 'date-fns/isValid'

export default {
  data() {
    return {
      rules: {
        required: (value?: any) =>
          !!value || this.translate('ERRORVALIDATION_REQUIRED'),

        passwordMin: (value: string) =>
          value.length >= 8 || this.translate('ERRORVALIDATION_PASSWORDMIN'),

        email: (value?: string) => {
          /**
           * Salesforce does not allow unicode in email adresses,
           * validate with html5 regex, same as symfony uses:
           * https://github.com/symfony/validator/blob/0cba85b9180823b3142a3f2cd66d7641a2811830/Constraints/EmailValidator.php#L26
           */
          const pattern = new RegExp(
            [
              /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9]/.source,
              /(?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?/.source,
              /(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/.source,
            ].join(''),
          )

          return pattern.test(value) || this.translate('ERRORVALIDATION_EMAIL')
        },

        phonenumber: (value?: string) => {
          if (!value) return true

          const pattern = /^(?:(?:00|\+|49)|0)[0-9\s-\\/()]{8,16}$/
          return pattern.test(value) || this.translate('ERRORVALIDATION_PHONE')
        },

        postcode: (value?: string) => {
          const pattern = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/
          return (
            pattern.test(value) || this.translate('ERRORVALIDATION_POSTCODE')
          )
        },

        age: (value?: string) => {
          const pattern = /^\d{1,3}$/
          return pattern.test(value) || this.translate('ERRORVALIDATION_AGE')
        },

        houseNumberMin: (value: string) =>
          value.length <= 5 || this.translate('ERRORVALIDATION_HOUSENUMBER'),

        termsofuse: (v?: any) =>
          !!v || this.translate('ERRORVALIDATION_TERMSOFUSE'),

        afterToday: (v?: string) => {
          const date = new Date(v)

          return (
            (isValid(date) && isAfter(date, endOfToday())) ||
            this.translate('ERRORVALIDATION_DATE_BEFORE_TOMORROW')
          )
        },

        notNullOrUndefined: (value?: any) =>
          (value !== null && value !== undefined) ||
          this.translate('ERRORVALIDATION_REQUIRED'),
      },
    }
  },

  methods: {
    containsKey(obj, key) {
      return Object.keys(obj).includes(key)
    },

    sanitizePhoneNumber(phoneNumber) {
      return phoneNumber.replace(/[-()\\/\s]/g, '')
    },
  },
}
